import React from 'react';
import BoldButton from '../Common/BoldButton';

interface IProps {
  canModify: boolean;
  onClick: () => void;
  className?: string;
}

const AssignSitesButton = ({ canModify, onClick, className }: IProps) =>
  <BoldButton className={className} onClick={onClick}>{canModify ? 'Assign Sites' : 'View Sites'}</BoldButton>;

export default AssignSitesButton;
